export const FORTY_FIVE_DAYS = 'forty_five_days';
export const THIRTY_DAYS = 'thirty_days';
export const FIFTEEN_DAYS = 'fifteen_days';
export const SEVENTY_TWO_HOURS = 'seventy_two_hours';
export const PAYMENT_CLIENT = 'payment_client';
export const FIVE_WORKING_DAYS = 'five_working_days';
export const FIFTEEN_WORKING_DAYS = 'fifteen_working_days';
export const IMMEDIATE = 'immediate';
export const TEN_DAYS = 'ten_days';
